<template>
  <div :class="{ active: isActive }" class="form">
    <div class="input-container">
      <label for="login-input" :class="[center_label ? 'centerlabel' : null]">{{ label }}</label>
      <input
        :type="inputType"
        id="login-input"
        @focus="focusInput"
        @blur="unfocus"
        :placeholder="PlaceHolder"
        @input="sendValue"
        v-model="value"
        :class="[center_label ? 'centerinput' : null]"
      />

      <small class="helpinput">{{ help }}</small>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    value: String,
    PlaceHolder: String,
    help: String,
    inputType: {
      default : "text",
      type :String
    },
    center_label: Boolean
  },
  data() {
    return {
      isActive: false,
      value: "",
    };
  },
  methods: {
    focusInput() {
      this.isActive = true;
    },
    unfocus() {
      if (this.value !== "") {
        this.isActive = true;
      } else {
        this.isActive = false;
      }
    },

    sendValue(e) {
      this.$emit("input", e.target.value);
    },
  },
};
</script>

<style scoped lang="scss">
.form {
  width: 100%;
  .input-container {
    width: 100%;
    border-bottom: 2px solid gray;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: flex-end;
    position: relative;
    margin-top: 50px;
    input {
      width: 100%;
      border: none;
      background-color: transparent;
      transition: ease all 0.5s;
      padding: 6px;
      &:focus {
        outline: none;
        border: none;
      }
      &::-webkit-input-placeholder {
        text-align: center;
        padding-bottom: 5px;
        font-size: 20px;
        color:#9e9e9e
      }

      &:-moz-placeholder { /* Firefox 18- */
        text-align: center;
        margin-bottom: 5px;
        font-size: 20px;
        color:#9e9e9e
      }

      &::-moz-placeholder {  /* Firefox 19+ */
        text-align: center;
        padding-bottom: 5px;
        font-size: 20px;
        color:#9e9e9e
      }

      &:-ms-input-placeholder {
        text-align: center;
        padding-bottom: 5px;
        font-size: 20px;
        color:#9e9e9e
      }
    }
    label {
      color: gray;
      font-size: 16px;
      position: absolute;
      bottom: 0;
      font-family: "sans";
      transition: ease all 0.5s;
    }
    .centerlabel{
      right: 0 !important;
      left: 0 !important;
      text-align: center;
      margin-bottom: 6px;
    }
    .centerinput{
      text-align: center;
      font-size: 20px;
    }
  }
}
.active {
  width: 100%;
  .input-container {
    border-bottom: 2px solid red !important;
    label {
      color: red;
      font-size: 16px;
      top: -20px;
    }
  }
}

.helpinput{
  position: absolute;
  top: 41px;
  font-family: 'sans';
  color: red;
  width: 109%;
  transform: scale(0.85);
}
</style>
